import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=20d063fe&scoped=true"
import script from "./ProjectInfo.vue?vue&type=script&lang=ts"
export * from "./ProjectInfo.vue?vue&type=script&lang=ts"
import style0 from "./ProjectInfo.vue?vue&type=style&index=0&id=20d063fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d063fe",
  null
  
)

export default component.exports